<template>
  <div>

    <div class="mb-4">
      <div class="font-weight-bold">Provide sample content</div>
      <div class="mt-2">Provide a piece of content for POP AI to draw inspiration from.</div>
    </div>

    <div>
      <v-textarea
        outlined
        dense
        :value="sampleContent"
        @input="$emit('update:sampleContent', $event)"
        color="greenColor"
        counter="500"
        placeholder="Add sample content"
        :counter-value="countWords"
        :rules="[(v) => countWords(v) <= 500 || `Must be less than 500 words`]"
      >
      </v-textarea>
    </div>

  </div>
</template>

<script>
export default {
    name: 'ConfigSampleContent',
    props: [
        'countWords',
        'sampleContent',
    ],
    computed: {

    }
}
</script>

<style lang="scss" scoped>

</style>